import type { ActionMessage } from '../types';
import { invokeAction } from './invoke';

export interface NativeUrlActionProps {
  readonly url: string;
  readonly downloadable: boolean;
  readonly rightBarButtonImageName?: string;
  readonly externalBrowser: boolean;
  readonly inAppBrowser: boolean;
  readonly fileExtension?: string | null;
  readonly analyticsParams?: Record<string, unknown>;
}

export type OpenUrlAction = ActionMessage<'url', NativeUrlActionProps>;
export const openUrl = invokeAction('appAction', 'url');
